import React, { FC } from 'react'
import { Stack } from 'rsuite'

import StarIconProgress, { StarProgress } from '../../Icons/StarIconProgress'
import { reviewRatingListItemKeys } from '../../../utils/reviewUtils'
import { isDefined } from '../../../utils/types/misc'

import styles from '../../../styles/SingleProductReviewsSection.module.less'

interface ReviewStarsProps {
  average: number
  minimize?: boolean
}

interface ReviewStarsWithDisplayedAverageProps {
  handleScrollToReviews?: () => void
  average?: number
  clickable?: boolean
  hideNumbers?: boolean
  reviewCount?: number
}

const progressPropMap = new Map<number, StarProgress>([
  [0, '0%'],
  [1, '25%'],
  [2, '50%'],
  [3, '75%'],
  [4, '100%'],
])

const ReviewStars: FC<ReviewStarsProps> = (props) => {
  const {
    average,
    minimize,
  } = props

  const renderStars = () => {
    const getProgressProp = (num: number) => progressPropMap.get(Math.round(4 * num)) ?? '0%'

    const starProgressProps = Array.from(
      { length: 5 },
      (_, i) => getProgressProp(Math.min(1, Math.max(0, average - i))),
    )

    const stars = starProgressProps.map((progress, index) => (
      <StarIconProgress
        progress={progress}
        key={`star-${reviewRatingListItemKeys[index]}`}
      />
    ))

    return stars
  }

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      className={minimize ? styles['review-stars-stack'] : ''}
    >
      {...renderStars()}
    </Stack>
  )
}

export default ReviewStars

export const ReviewStarsWithDisplayedAverage: FC<ReviewStarsWithDisplayedAverageProps> = ({
  average,
  handleScrollToReviews,
  hideNumbers = false,
  reviewCount,
}) => {
  if (isDefined(average) && average) {
    return (
      <Stack
        direction="row"
        spacing={reviewCount ? 0 : 5}
        className={`${styles['stack-custom-spacing']} ${handleScrollToReviews ? styles['nav-star'] : ''}`}
        onClick={() => handleScrollToReviews?.()}
      >
        <ReviewStars
          average={average}
          minimize
        />
        {reviewCount && (
          <p className={styles['review-stars-text']}>
            {`(${reviewCount})`}
          </p>
        )}
        {!hideNumbers && (
          <p className={styles['review-stars-text']}>
            {`${average?.toFixed(1)} / 5`}
          </p>
        )}
      </Stack>
    )
  }

  return null
}
